<template>
    <v-container grid-list-lg>
        <v-layout row wrap style="padding-bottom:20px"> 
               <v-loading class="loading" v-model="loading" v-if="loading">
    
                    <v-progress-circular persistent
                    :size="70"
                    :width="7"
                    color="primary"
                    indeterminate
                    ></v-progress-circular>
            
                </v-loading>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Meus alunos</v-toolbar-title>
                    <v-btn outline color="white" @click="redirectDiario()" style="position:absolute; right:10px; top:7px">Diário</v-btn>
                </v-toolbar>

                

                
                
                <!--v-flex v-for="i in 10" :key="`4${i}`" xs12 sm8 md4-->
                <!--v-flex v-for="(fotografo, idx) in 10" :key="idx" xs12 sm8 md4-->
                <v-flex v-for="(item, index) in items" xs12 sm6 md4 row card style="margin-bottom:5px; padding:1px">
                    
                    <v-card>
                    
                        <v-card-text>
                            <!--v-btn class="deletar" flat color="orange" flat="flat" @click="deletarItem(item.slug)">x</v-btn-->
                            <v-card-title primary-title>
                                <!--div class="imagem"  style="background-image: url('http://www.closebecoming.co.uk/images/category_10/Honey%20%20B%20Women%20Black%20Self%20Design%20Top%20Beautiful%20BLOVOT.jpg');" ></div-->
                                <div class="imagem" v-bind:style="{ 'background-image': 'url(' + item.imagem + ')' }" ></div>
                                <div style="width:66%" class="body-content">
                                    
                                    <h3 class="headline mb-0" :title="item.nome">{{item.nome}}</h3> <!-- {{ parentMessage }} - {{ index }} - {{ item.message }} -->
                                    <div>{{item.email}}</div>
                                    <div>{{item.telefone}}</div><br /><!--{{item.slug}}-->
                                    
                                </div>
                            </v-card-title> 

                            <v-card-actions>
                                <div class="instagram" style="height:20px;"><a @click="diarioFiltradoPorAluno(item.slugAluno)">Diário</a></div>
                                <v-btn class="editar" flat color="orange" flat="flat" @click="chegou(item.slugAluno)">Chegou</v-btn>
                                <v-btn class="release" flat color="orange" flat="flat" @click="saiu(item.slugAluno)">Saiu</v-btn>
                                
                            </v-card-actions>
                            
                        </v-card-text>
                    
                    </v-card>
                </v-flex>
                
            

                
            
        </v-layout>
        <v-dialog v-model="dialogDeleteConfirm" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Do you want to delete this model?</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="dialogDeleteConfirm = false">No</v-btn>
                <v-btn color="green darken-1" flat @click="deletarItemConfirm">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Item deletado com sucesso!</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="dialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogEntradaSaida" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{textoDialogEntradaSaida}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="dialogEntradaSaida = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        
    </v-container>
</template>

<script>

import db from './firebaseInit';
import firebase from 'firebase';

import { userProperties, usersData } from '@/global.js'

import axios from 'axios'
import VueAxios from 'vue-axios'

export default {
    name: 'Meus-Alunos',
    head: {
        script: [
            { src: 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.1.1/jquery.min.js' },
        ]
    },
    data () {
        return {
            slug : '',
            slugAluno : null,
            loading: false,
            dialog: false,
            dialogDeleteConfirm: false,
            modalMessage: 'Modelo excluído com sucesso!',
            items: [],
            allItems: [],
            urlImg: null,
            dialogEntradaSaida: null,
            textoDialogEntradaSaida: null
        }
    },
    methods: {
        carregaDados() {

            // Popula o numero de quantidade de notificações
            db.collection('notificacoes').where("destinatario", "==", userProperties.slug)
            .get()
            .then((querySnapshot) => {
                // set cookie
                $.cookie("qtdNotificacoes", querySnapshot.size, { expires: 60 });
                
                
            });

            var that = this;

            //console.log(userProperties.turmas);

            var user = firebase.auth().currentUser;
            var name, email, photoUrl, uid, emailVerified;
            
            // Obtém os dados da sessionStorage
            var emailLogado = sessionStorage.getItem('email');
            console.log(emailLogado);


            this.items = []
            this.loading = true
            
            db.collection("usuarios")
            .where("escolaID", "==", userProperties.escolaID).where("perfil", "==", 7)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach(doc => {
                    
                    // doc.data() is never undefined for query doc snapshots
                    //console.log(doc.id, " => ", doc.data());                    
                    let customObj = doc.data();

                    // recupera imagem do firebase storage
                    var storageRef = firebase.storage().ref();
                    var tangRef = storageRef.child('profile/'+customObj.slug+'.'+customObj.extensao);

                    // First we sign in the user anonymously
                    //firebase.auth().signInAnonymously().then((result) => {
                    // Once the sign in completed, we get the download URL of the image
                    tangRef.getDownloadURL().then(urlImgFB =>                             {
                        // Once we have the download URL, we set it to our img element
                        //console.log(urlImgFB);
                        this.urlImg = urlImgFB;

                        // Valida se turma dos usuários(aluno) é igual ao do usuario logado(professor)
                        userProperties.turmas.forEach(function(item, index){
                            //alert("for1"+item);
                            customObj.turmas.forEach(function(item2, index2){
                                //alert("for2"+item2);
                                if(item == item2){
                                    that.items.push({"nome": customObj.nome, "email": customObj.email, "telefone": customObj.telefone, "slugAluno": customObj.slug, "imagem": urlImgFB, "turmas": customObj.turmas});
                                }
                            });
                        });
                        
                        //this.slugAluno = customObj.slug;
                        //this.loading = false

                        }).catch(function(error) {
                            // If anything goes wrong while getting the download URL, log the error,
                            console.error(error);
                        });
                    

                });
                this.loading = false
                console.log(this.items);
                

                
                
            });

            function compare( a, b ) {
                if ( a.nome < b.nome ){
                    return -1;
                }
                if ( a.nome > b.nome ){
                    return 1;
                }
                return 0;
            }

            
            this.items = this.items.sort( compare );
            console.log(this.items.sort( compare ));
            // this.items = obj
            // console.log("XXXXXX"+obj)
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },
        chegou(aluno){

            // Log do sistema
            if(userProperties.escolaID != null){            
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second

                db.collection('log_' + userProperties.escolaID).add({
                        escolaID: userProperties.escolaID,
                        slugAutor: userProperties.slug,
                        perfil: userProperties.perfil,
                        
                        //slug: this.slug,
                        customtimestamp: customtimestamp,
                        dia: day,
                        mes: month,
                        ano: year,
                        acao: "criar chegou",
                        categoria: "diario",
                        pontos: 1
                        
                    })
                    .then(docRef => {
                        console.log('Document written with ID: ', docRef.id);

                        
                    })
                    .catch(function (error) {
                        console.log('Error adding document: ', error);
                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                    })
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }

            var that = this;
            this.loading = true;

            var nomeAluno = null;

            const slug = this.generateUUID()

            // timestamp - data atual
            var now = new Date();
            var year = "" + now.getFullYear();
            var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
            var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
            var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
            var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
            var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
            //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
            var customtimestamp = year + month + day + hour + minute + second
            
            var dataAtual = year + "-" + month + "-" + day;
            
            db.collection('resumodiario_'+userProperties.escolaID).where("aluno.alunoSlug", "==", aluno).where("date", "==", dataAtual)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){ // nao possuir registro na data atual
                    if(userProperties.escolaID != null){
                        this.loading = true

                        db.collection('resumodiario_'+userProperties.escolaID).add({
                                escolaID: userProperties.escolaID,
                                slugAutor: userProperties.slug,
                                
                                slug: slug,
                                customtimestamp: customtimestamp,

                                date: dataAtual,
                                ano: dataAtual.substring(0,4),
                                mes: dataAtual.substring(5,7),
                                dia: dataAtual.substring(8,10),
                                entrada: hour + ":" + minute,
                                saida: null,
                                horasSono: null,
                                evacuacaoName: null,
                                evacuacaoID: null,
                                cafeManhaName: null,
                                cafeManhaID: null,
                                almocoName: null,
                                almocoID: null,
                                cafeTardeName: null,
                                cafeTardeID: null,
                                jantaName: null,
                                jantaID: null,
                                licaoCasa: null,
                                banho: null,
                                rating: 2,
                                observacao: null,
                                aluno: {"alunoSlug": aluno}
                                //aluno: {"alunoName": "XXX", "alunoSlug": aluno}

                            })
                            .then(docRef => {
                                this.textoDialogEntradaSaida = "Horário de entrada registrado com sucesso!";
                                this.dialogEntradaSaida = true
                                this.loading = false;

                                // Busca Slug dos responsaveis para envio do push
                                var responsaveisDoAlunoSlug = [];
                                usersData.usuarios.forEach(function(item, index){
                                    if(item.slug == aluno){
                                        nomeAluno = item.nome;
                                        item.responsaveis.forEach(function(item2, index2){
                                            if(item2.length != 0){
                                                //alert("responsavel="+item2.responsavelSlug);
                                                //alert("FCM="+item.tokenFMC);
                                                responsaveisDoAlunoSlug.push(item2.responsavelSlug)

                                            }
                                        })
                                    }
                                });

                                //Busca FMC com base nos slugs selecionados acima
                                var responsaveisDoAlunoFCM = [];
                                usersData.usuarios.forEach(function(item, index){
                                    responsaveisDoAlunoSlug.forEach(function(item2, index2){
                                        if(item2.length != 0){
                                            if(item.slug == item2){
                                                responsaveisDoAlunoFCM.push(item.tokenFMC)
                                            }
                                        }
                                    })
                                });

                                responsaveisDoAlunoFCM.forEach(function(item3, index3){
                                        console.log("entrou no if de enviar push");
                                        var postData = {
                                            "notification": {        
                                                "title": "Notificação de entrada!",
                                                "body": "O aluno(a) " + nomeAluno + " acabou de chegar.",
                                                "click_action": "https://inclass.app",
                                                "icon": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                "badge": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                //"image": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                "sound": "default"
                                            },    
                                            //"to": "egWUxBfoF_M:APA91bFI3XEPVD6dFP9W2_G__J9DzbTb9qpmFBW0NGRhcBTVxdNM_j_VOKo5V79Ro1-jmZLXYv6Wzq39ELzMUW-TTHAS7Nb6FSt762n_8E7SCwtHfFwn-QRClj3SD5mH2iO5sijMHY0a"
                                            "to": item3
                                        }

                                        let axiosConfig = {
                                            headers: {
                                                'Content-Type': 'application/json',
                                                "Authorization": "key=AAAAiOjxl8Q:APA91bHly_RtJvUwP5kzHiHbulyRMI7oChExHjzyf1MFimlObjrX_-kRxCMWW77a2hBBxU7Oz-BhnFBANbCBHMObkiKAMHZSgxfw47LKjwGTRs6DCjtDkvvyRLiJcCMBHHh4uS93E0ha",
                                            }
                                        };

                                        axios.post('https://fcm.googleapis.com/fcm/send', postData, axiosConfig)
                                        .then((res) => {
                                            console.log("PUSH ENVIADO. RESPONSE RECEIVED: ", res);
                                        })
                                        .catch((err) => {
                                            console.log("ERRO AO ENVIAR PUSH. AXIOS ERROR: ", err);
                                            alert("Erro no envio de push.")
                                        })
                                }); 
                                
                                
                                

                                console.log('Document written with ID: ', docRef.id);
                                //this.$router.push(`/${slug}/success`)
                                
                            })
                            .catch(function (error) {
                                that.loading = false
                                console.log('Error adding document: ', error);
                                console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                            })
                    }
                    else{
                        alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                        this.$router.push(`/`);
                    }
                }
                else{

                        querySnapshot.forEach(doc => {
                            // doc.data() is never undefined for query doc snapshots
                            console.log(doc.id, " => ", doc.data());               
                            let customObj = doc.data()
                            if(customObj.entrada == null){
                                db.collection('resumodiario_'+userProperties.escolaID).doc(doc.id).update({                        

                                entrada: hour + ":" + minute
                          

                            }).then(docRef => {
                                this.textoDialogEntradaSaida = "Horário de entrada registrado com sucesso!";
                                this.dialogEntradaSaida = true
                                
                                                                // Busca Slug dos responsaveis para envio do push
                                var responsaveisDoAlunoSlug = [];
                                usersData.usuarios.forEach(function(item, index){
                                    if(item.slug == aluno){
                                        nomeAluno = item.nome;
                                        item.responsaveis.forEach(function(item2, index2){
                                            if(item2.length != 0){
                                                //alert("responsavel="+item2.responsavelSlug);
                                                //alert("FCM="+item.tokenFMC);
                                                responsaveisDoAlunoSlug.push(item2.responsavelSlug)

                                            }
                                        })
                                    }
                                });

                                //Busca FMC com base nos slugs selecionados acima
                                var responsaveisDoAlunoFCM = [];
                                usersData.usuarios.forEach(function(item, index){
                                    responsaveisDoAlunoSlug.forEach(function(item2, index2){
                                        if(item2.length != 0){
                                            if(item.slug == item2){
                                                responsaveisDoAlunoFCM.push(item.tokenFMC)
                                            }
                                        }
                                    })
                                });
                                
                                responsaveisDoAlunoFCM.forEach(function(item3, index3){
                                        console.log("entrou no if de enviar push");
                                        var postData = {
                                            "notification": {        
                                                "title": "Notificação de chegada!",
                                                "body": "O aluno(a) " + nomeAluno + " acabou de chegar.",
                                                "click_action": "https://inclass.app",
                                                "icon": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                "badge": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                //"image": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                "sound": "default"
                                            },    
                                            //"to": "egWUxBfoF_M:APA91bFI3XEPVD6dFP9W2_G__J9DzbTb9qpmFBW0NGRhcBTVxdNM_j_VOKo5V79Ro1-jmZLXYv6Wzq39ELzMUW-TTHAS7Nb6FSt762n_8E7SCwtHfFwn-QRClj3SD5mH2iO5sijMHY0a"
                                            "to": item3
                                        }

                                        let axiosConfig = {
                                            headers: {
                                                'Content-Type': 'application/json',
                                                "Authorization": "key=AAAAiOjxl8Q:APA91bHly_RtJvUwP5kzHiHbulyRMI7oChExHjzyf1MFimlObjrX_-kRxCMWW77a2hBBxU7Oz-BhnFBANbCBHMObkiKAMHZSgxfw47LKjwGTRs6DCjtDkvvyRLiJcCMBHHh4uS93E0ha",
                                            }
                                        };

                                        axios.post('https://fcm.googleapis.com/fcm/send', postData, axiosConfig)
                                        .then((res) => {
                                            console.log("PUSH ENVIADO. RESPONSE RECEIVED: ", res);
                                        })
                                        .catch((err) => {
                                            console.log("ERRO AO ENVIAR PUSH. AXIOS ERROR: ", err);
                                            alert("Erro no envio de push.")
                                        })
                                });

                                console.log('Document written with ID: ', docRef.id);
                                //this.$router.push(`/${slug}/success`)
                                this.loading = false
                                this.dialog = true
                                
                            })
                            .catch(function (error) {
                                that.loading = false
                                console.log('Error adding document: ', error);
                                console.log("Erro na atualização dos dados. Tente novamente mais tarde!")
                            })        
                            }
                            else{ // se existir diario e hora de entrada já registrada
                                this.textoDialogEntradaSaida = "Horário de entrada já havia sido registrado para esse aluno!";
                                this.dialogEntradaSaida = true
                            }

                            //this.date = customObj.date,
                            
                        });
                    
                        
                }
                

                // Marca carinha/rating selecionada
                var itemRating = Number(this.rating) - 1;
                $(".custom-rating a:eq("+itemRating+")").click();

                this.loading = false;

            });
        },
        saiu(aluno){

            // Log do sistema
            if(userProperties.escolaID != null){            
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second

                db.collection('log_' + userProperties.escolaID).add({
                        escolaID: userProperties.escolaID,
                        slugAutor: userProperties.slug,
                        perfil: userProperties.perfil,
                        
                        slug: this.slug,
                        customtimestamp: customtimestamp,
                        dia: day,
                        mes: month,
                        ano: year,
                        acao: "criar saiu",
                        categoria: "diario",
                        pontos: 1
                        
                    })
                    .then(docRef => {
                        console.log('Document written with ID: ', docRef.id);

                        
                    })
                    .catch(function (error) {
                        console.log('Error adding document: ', error);
                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                    })
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }

            var that = this;
            this.loading = true;

            var nomeAluno = null;

            const slug = this.generateUUID()

            // timestamp - data atual
            var now = new Date();
            var year = "" + now.getFullYear();
            var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
            var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
            var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
            var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
            var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
            //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
            var customtimestamp = year + month + day + hour + minute + second
            
            var dataAtual = year + "-" + month + "-" + day;
            
            db.collection('resumodiario_'+userProperties.escolaID).where("aluno.alunoSlug", "==", aluno).where("date", "==", dataAtual)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){ // se não existir registro nessa data
                    if(userProperties.escolaID != null){
                        this.loading = true
                        
                        db.collection('resumodiario_'+userProperties.escolaID).add({
                                escolaID: userProperties.escolaID,
                                slugAutor: userProperties.slug,
                                
                                slug: slug,
                                customtimestamp: customtimestamp,

                                date: dataAtual,
                                ano: dataAtual.substring(0,4),
                                mes: dataAtual.substring(5,7),
                                dia: dataAtual.substring(8,10),
                                entrada: null,
                                saida: hour + ":" + minute,
                                horasSono: null,
                                evacuacaoName: null,
                                evacuacaoID: null,
                                cafeManhaName: null,
                                cafeManhaID: null,
                                almocoName: null,
                                almocoID: null,
                                cafeTardeName: null,
                                cafeTardeID: null,
                                jantaName: null,
                                jantaID: null,
                                licaoCasa: null,
                                banho: null,
                                rating: 2,
                                observacao: null,
                                aluno: {"alunoSlug": aluno}
                                //aluno: {"alunoName": "XXX", "alunoSlug": aluno}

                            })
                            .then(docRef => {
                                //alert("enviar push para os responsaveis desse aluno");
                                this.textoDialogEntradaSaida = "Horário de saída registrado com sucesso, porém esse aluno não possui registro de entrada hoje. Não esqueça de adicionar a entrada no diário!!!";
                                this.dialogEntradaSaida = true
                                this.loading = false;
                                
                                                                // Busca Slug dos responsaveis para envio do push
                                var responsaveisDoAlunoSlug = [];
                                usersData.usuarios.forEach(function(item, index){
                                    if(item.slug == aluno){
                                        nomeAluno = item.nome;
                                        item.responsaveis.forEach(function(item2, index2){
                                            if(item2.length != 0){
                                                //alert("responsavel="+item2.responsavelSlug);
                                                //alert("FCM="+item.tokenFMC);
                                                responsaveisDoAlunoSlug.push(item2.responsavelSlug)

                                            }
                                        })
                                    }
                                });

                                //Busca FMC com base nos slugs selecionados acima
                                var responsaveisDoAlunoFCM = [];
                                usersData.usuarios.forEach(function(item, index){
                                    responsaveisDoAlunoSlug.forEach(function(item2, index2){
                                        if(item2.length != 0){
                                            if(item.slug == item2){
                                                responsaveisDoAlunoFCM.push(item.tokenFMC)
                                            }
                                        }
                                    })
                                });
                                
                                responsaveisDoAlunoFCM.forEach(function(item3, index3){
                                        console.log("entrou no if de enviar push");
                                        var postData = {
                                            "notification": {        
                                                "title": "Notificação de saída",
                                                "body": "O aluno(a) " + nomeAluno + " acabou de sair.",
                                                "click_action": "https://inclass.app",
                                                "icon": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                "badge": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                //"image": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                "sound": "default"
                                            },    
                                            //"to": "egWUxBfoF_M:APA91bFI3XEPVD6dFP9W2_G__J9DzbTb9qpmFBW0NGRhcBTVxdNM_j_VOKo5V79Ro1-jmZLXYv6Wzq39ELzMUW-TTHAS7Nb6FSt762n_8E7SCwtHfFwn-QRClj3SD5mH2iO5sijMHY0a"
                                            "to": item3
                                        }

                                        let axiosConfig = {
                                            headers: {
                                                'Content-Type': 'application/json',
                                                "Authorization": "key=AAAAiOjxl8Q:APA91bHly_RtJvUwP5kzHiHbulyRMI7oChExHjzyf1MFimlObjrX_-kRxCMWW77a2hBBxU7Oz-BhnFBANbCBHMObkiKAMHZSgxfw47LKjwGTRs6DCjtDkvvyRLiJcCMBHHh4uS93E0ha",
                                            }
                                        };

                                        axios.post('https://fcm.googleapis.com/fcm/send', postData, axiosConfig)
                                        .then((res) => {
                                            console.log("PUSH ENVIADO. RESPONSE RECEIVED: ", res);
                                        })
                                        .catch((err) => {
                                            console.log("ERRO AO ENVIAR PUSH. AXIOS ERROR: ", err);
                                            alert("Erro no envio de push.")
                                        })
                                });

                                

                                console.log('Document written with ID: ', docRef.id);
                                //this.$router.push(`/${slug}/success`)
                                
                            })
                            .catch(function (error) {
                                that.loading = false
                                console.log('Error adding document: ', error);
                                console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                            })
                    }
                    else{
                        alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                        this.$router.push(`/`);
                    }
                }
                else{
                    querySnapshot.forEach(doc => {
                        // doc.data() is never undefined for query doc snapshots
                        console.log(doc.id, " => ", doc.data());               
                        let customObj = doc.data()
                        if(customObj.entrada != null && customObj.saida == null){
                            db.collection('resumodiario_'+userProperties.escolaID).doc(doc.id).update({                        

                                saida: hour + ":" + minute
                        

                            }).then(docRef => {
                                this.textoDialogEntradaSaida = "Horário de saída registrado com sucesso!";
                                this.dialogEntradaSaida = true
                                this.loading = false;
                                
                                
                                // Busca Slug dos responsaveis para envio do push
                                var responsaveisDoAlunoSlug = [];
                                usersData.usuarios.forEach(function(item, index){
                                    if(item.slug == aluno){
                                        nomeAluno = item.nome;
                                        item.responsaveis.forEach(function(item2, index2){
                                            if(item2.length != 0){
                                                //alert("responsavel="+item2.responsavelSlug);
                                                //alert("FCM="+item.tokenFMC);
                                                responsaveisDoAlunoSlug.push(item2.responsavelSlug)

                                            }
                                        })
                                    }
                                });

                                //Busca FMC com base nos slugs selecionados acima
                                var responsaveisDoAlunoFCM = [];
                                usersData.usuarios.forEach(function(item, index){
                                    responsaveisDoAlunoSlug.forEach(function(item2, index2){
                                        if(item2.length != 0){
                                            if(item.slug == item2){
                                                responsaveisDoAlunoFCM.push(item.tokenFMC)
                                            }
                                        }
                                    })
                                });
                                
                                responsaveisDoAlunoFCM.forEach(function(item3, index3){
                                        console.log("entrou no if de enviar push");
                                        var postData = {
                                            "notification": {        
                                                "title": "Notificação de saída",
                                                "body": "O aluno(a) " + nomeAluno + " acabou de sair.",
                                                "click_action": "https://inclass.app",
                                                "icon": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                "badge": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                //"image": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                "sound": "default"
                                            },    
                                            //"to": "egWUxBfoF_M:APA91bFI3XEPVD6dFP9W2_G__J9DzbTb9qpmFBW0NGRhcBTVxdNM_j_VOKo5V79Ro1-jmZLXYv6Wzq39ELzMUW-TTHAS7Nb6FSt762n_8E7SCwtHfFwn-QRClj3SD5mH2iO5sijMHY0a"
                                            "to": item3
                                        }

                                        let axiosConfig = {
                                            headers: {
                                                'Content-Type': 'application/json',
                                                "Authorization": "key=AAAAiOjxl8Q:APA91bHly_RtJvUwP5kzHiHbulyRMI7oChExHjzyf1MFimlObjrX_-kRxCMWW77a2hBBxU7Oz-BhnFBANbCBHMObkiKAMHZSgxfw47LKjwGTRs6DCjtDkvvyRLiJcCMBHHh4uS93E0ha",
                                            }
                                        };

                                        axios.post('https://fcm.googleapis.com/fcm/send', postData, axiosConfig)
                                        .then((res) => {
                                            console.log("PUSH ENVIADO. RESPONSE RECEIVED: ", res);
                                        })
                                        .catch((err) => {
                                            console.log("ERRO AO ENVIAR PUSH. AXIOS ERROR: ", err);
                                            alert("Erro no envio de push.")
                                        })
                                });

                                //this.$router.push(`/${slug}/success`)
                                this.loading = false
                                
                            })
                            .catch(function (error) {
                                that.loading = false
                                console.log('Error adding document: ', error);
                                console.log("Erro na atualização dos dados. Tente novamente mais tarde!")
                            })        
                        }
                        else{ // se existir diario e hora de entrada já registrada
                            this.textoDialogEntradaSaida = "Horário de saída já havia sido registrado para esse aluno!";
                            this.dialogEntradaSaida = true
                        }



                        if(customObj.entrada == null && customObj.saida == null){
                            db.collection('resumodiario_'+userProperties.escolaID).doc(doc.id).update({                        

                                saida: hour + ":" + minute
                        

                            }).then(docRef => {
                                this.textoDialogEntradaSaida = "Horário de saída registrado com sucesso, porém esse aluno não possui registro de entrada hoje. Não esqueça de adicionar a entrada no diário!!!";
                                this.dialogEntradaSaida = true
                                this.loading = false;
                                
                                
                                // Busca FCM dos responsaveis para envio do push
                                var responsaveisDoAlunoFCM = [];
                                usersData.usuarios.forEach(function(item, index){
                                    if(item.slug == aluno){
                                        nomeAluno = item.nome;
                                        item.responsaveis.forEach(function(item2, index2){
                                            if(item2.length != 0){
                                                //alert("responsavel="+item2.responsavelSlug);
                                                //alert("FCM="+item.tokenFMC);
                                                responsaveisDoAlunoFCM.push(item.tokenFMC)

                                            }
                                        })
                                    }
                                });
                                
                                responsaveisDoAlunoFCM.forEach(function(item3, index3){
                                        console.log("entrou no if de enviar push");
                                        var postData = {
                                            "notification": {        
                                                "title": "Notificação de saída",
                                                "body": "O aluno(a) " + nomeAluno + " acabou de sair.",
                                                "click_action": "https://inclass.app",
                                                "icon": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                "badge": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                //"image": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                                "sound": "default"    
                                            },    
                                            //"to": "egWUxBfoF_M:APA91bFI3XEPVD6dFP9W2_G__J9DzbTb9qpmFBW0NGRhcBTVxdNM_j_VOKo5V79Ro1-jmZLXYv6Wzq39ELzMUW-TTHAS7Nb6FSt762n_8E7SCwtHfFwn-QRClj3SD5mH2iO5sijMHY0a"
                                            "to": item3
                                        }

                                        let axiosConfig = {
                                            headers: {
                                                'Content-Type': 'application/json',
                                                "Authorization": "key=AAAAiOjxl8Q:APA91bHly_RtJvUwP5kzHiHbulyRMI7oChExHjzyf1MFimlObjrX_-kRxCMWW77a2hBBxU7Oz-BhnFBANbCBHMObkiKAMHZSgxfw47LKjwGTRs6DCjtDkvvyRLiJcCMBHHh4uS93E0ha",
                                            }
                                        };

                                        axios.post('https://fcm.googleapis.com/fcm/send', postData, axiosConfig)
                                        .then((res) => {
                                            console.log("PUSH ENVIADO. RESPONSE RECEIVED: ", res);
                                        })
                                        .catch((err) => {
                                            console.log("ERRO AO ENVIAR PUSH. AXIOS ERROR: ", err);
                                            alert("Erro no envio de push.")
                                        })
                                });

                                //this.$router.push(`/${slug}/success`)
                                this.loading = false
                                
                            })
                            .catch(function (error) {
                                that.loading = false
                                console.log('Error adding document: ', error);
                                console.log("Erro na atualização dos dados. Tente novamente mais tarde!")
                            })        
                        }
                        else{ // se existir diario e hora de entrada já registrada
                            this.textoDialogEntradaSaida = "Horário de saída já havia sido registrado para esse aluno!";
                            this.dialogEntradaSaida = true
                        }

                        //this.date = customObj.date,
                        
                    });

                        
                        
                    
                }
                

                // Marca carinha/rating selecionada
                var itemRating = Number(this.rating) - 1;
                $(".custom-rating a:eq("+itemRating+")").click();

                this.loading = false;

            });
        },
        redirectDiario(){
            this.$router.push(`/resumo-diario-listagem`);
            
        },
        diarioFiltradoPorAluno(slugAluno){
            this.$router.push(`/resumo-diario-listagem/?slugAluno=`+slugAluno);
        },
        editarItem(slug){
            var emailLogado = sessionStorage.getItem('email');
            if(emailLogado == "pevidephotography@gmail.com"){
                this.$router.push(`/modeloedit/?slug=`+slug)
            }
            else{
                this.$router.push(`/modeloeditbr/?slug=`+slug)
            }
            
        },
        displayItem(slug){
            var emailLogado = sessionStorage.getItem('email');
            if(emailLogado == "pevidephotography@gmail.com"){
                this.$router.push(`/modelodisplay/?slug=`+slug)
            }
            else{
                this.$router.push(`/modelodisplaybr/?slug=`+slug)
            }
        },
        closeModal() {
            this.dialog = false      
            this.$router.push(`/`)
            this.$forceUpdate()
            Vue.delete(state.fixture, i)
        }   
        
    },
  created() {
    this.carregaDados();
    this.allItems = this.items;
  }
};



</script>

<style scoped>
    .loading{
        position: fixed;
        top:20%;
        left:41%;
        z-index: 2;
    }

    .deletar{
        position: absolute;
        min-width: auto;
        height: auto;
        padding: 1px 6px !important;
        right: 0;
        top: 0;
    }

    .release{
        background-color:beige;
        position:absolute;
        right: 12px;

    }

    .editar{
        background-color:beige;
        position:absolute;
        right: 112px;

    }

    .imagem{
        width: 80px;
        height: 80px;
        margin-right: 12px;
        border:beige solid 1px;
        border-radius: 50%;
        background-position: center top;
        background-size: 100% auto;
        position: relative;
        top:-6px;
    }

    .instagram{
        position: absolute;
        left: 15px;
    }

    .body-content .headline{
        font-size: 16px !important;
        font-weight: bold;
        overflow: hidden;
        height: 28px;
    }

    .hide{
        display: none;
    }

    .v-card__text .v-input--selection-controls .v-input__control, .v-input__control{
        width: 100% !important;
    }

    .v-card__actions{
        height: 20px;
    }

    

    @media screen and (max-width: 769px) {
        .v-input--selection-controls .v-input__control{
            width:100% !important;
        }
    }

    @media screen and (max-width: 569px) {
        .btClear{
            padding-top: 0 !important;
            position: relative;
            top:-15px;
            left:-5px;
        }
    }
</style>
